import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { actions as builderActions } from '../../../../tradebuilder-v2/modules/00-builder/state/builder-slice'
import { actions as termsStateActions } from '../../../../tradebuilder-v2/modules/02-terms/state/terms-slice'
import { useAppDispatch, useAppSelector } from '../../../../tradebuilder-v2/store/hooks'
import { useActions } from '../../../../tradebuilder-v2/store/use-actions'
import { TopUpWithdrawState } from '../../../types/TopUpWithdrawState'
import { actions as topupWithdrawActions } from '../state/topup-withdraw-slice'
import TradeTopupWithdrawStateless from '../templates/trade-topup-withdraw-stateless'

const TradeTopupWithdraw = () => {
  const builderState = useAppSelector(state => state.builder)
  const state = useAppSelector(state => state.topupWithdraw)
  const actions = useActions(topupWithdrawActions)
  const termsActions = useActions(termsStateActions)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if (state.success === true) {
      dispatch(builderActions.refreshTradeStatus(String(builderState.accountId)))
    }
  }, [builderState.accountId, dispatch, state.success])

  const onSave = () => {
    actions.updateAndMoveNext()
  }
  const onClose = () => {
    navigate(`/trades/close/${builderState.accountId}`)
  }
  const onCloseAll = () => {
    navigate(`/trades/closeall/${builderState.accountId}`)
  }
  const onChangeAmount = (updatedValue: number) => {
    actions.updateChangeAmount({ updatedAmount: updatedValue })
  }
  const onChangeSelection = (state: TopUpWithdrawState) => {
    actions.updateSelectionState(state)
    if (state === TopUpWithdrawState.Topup) {
      termsActions.setSettlementRequired(true)
    } else {
      termsActions.setSettlementRequired(false)
    }
  }

  const isLoading =
    !builderState.accountId || !window.location.pathname.includes(builderState.accountId)

  return (
    <TradeTopupWithdrawStateless
      key={builderState.accountId}
      isLoading={isLoading}
      state={state}
      onChangeAmount={onChangeAmount}
      onChangeSelection={onChangeSelection}
      onClose={onClose}
      onCloseAll={onCloseAll}
      onSave={onSave}
    />
  )
}

export default TradeTopupWithdraw
